import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { SclUtilUrlService } from '../../../../formbird-sc-shared/src/lib/scl-util-url.service';
import { SclUtilValidationService } from '../../../../formbird-sc-shared/src/lib/scl-util-validation.service';
import { UtilSharingNgService } from '../../../../formbird-sc-shared/src/lib/util-sharing-ng.service';
import { FormbirdInjectorService } from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import { SearchService } from '../../../../formbird-services/src/lib/services/search/search.service';

const logger = console;
declare const $;

interface HelpButtonComponentDefinition extends ComponentDefinition {
  enabled: boolean;
  name: string;
  label: string;
  helpHeight?: any;
  helpFormat?: any;
  helpTemplateId?: string;
  helpDocumentId?: string;
  keyIds?: any;
  helpFieldName?: any;
  caption?: string;
  onClick?: string;
  style?: string;
  icon?: string;
  css?: string;
  class?: string;
  color?: string;
  enableAutoGenFields?: boolean;
  helpDisplayWidth?: string;
}

@Component({
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpButtonComponent extends AbstractComponent<HelpButtonComponentDefinition> implements OnInit {
  @Input() responsiveLayouts: string;

  @ViewChild('elBtn', {static: true}) elBtn: ElementRef;

  // services
  $injector: any;

  //
  btnLabel: string;
  defaultStyle = 'btn btn-default';
  primaryStyle = 'btn btn-primary';

  icon = '';
  css;
  color;

  hasAccess: any;
  private notificationService: any;
  private loggedInUserService: any;
  private modifiedFieldService: any;
  private userAccountControlDocument: any;
  private user: any;
  private isMainDocumentDirty: any;
  private selectedFieldName: string;
  private selectedHelpFieldName: any;
  private modalTitle: string;
  private helpUrl: string;
  private dataService: any;
  defaultHelpTemplateId = 'cb1af5c0-95e2-11e9-8108-e9db4351ffae';
  private documentModalService: any;
  private modifiedDocument: any;
  private currentDocumentService: any;
  private enableAutoGenFields: any;
  private btnHelpElem: any;
  private helpDisplayWidth: string;

  constructor(
    protected changedDocumentService: ChangedDocumentService,
    protected formbirdInjectorService: FormbirdInjectorService,
    protected cdr: ChangeDetectorRef,
    private searchService: SearchService,
    protected componentSetupService: ComponentSetupService,
    private sclUtilValidation: SclUtilValidationService,
    private sclUtilUrlService: SclUtilUrlService,
    private utilSharingNgService: UtilSharingNgService,
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.modifiedFieldService = this.formbirdInjectorService.get('ModifiedFieldService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.user = this.loggedInUserService.user.account;
    this.userAccountControlDocument = this.loggedInUserService.user.accountControlDocument;
    this.documentModalService = this.formbirdInjectorService.get('DocumentModalService');
    this.$injector = this.formbirdInjectorService;
    this.currentDocumentService = this.formbirdInjectorService.get('CurrentDocumentService');
  }

  ngOnInit(): void {

    this.disabled = this.componentDefinition.enabled === false;

    this.btnLabel = this.componentDefinition.caption ? this.componentDefinition.caption : this.componentDefinition.label;

    this.icon = '';
    if (!(typeof this.componentDefinition.icon === 'undefined' || this.componentDefinition.icon === null)) {
      this.icon = this.componentDefinition.icon;
    }
    if (!(typeof this.componentDefinition.enableAutoGenFields === 'undefined' || this.componentDefinition.enableAutoGenFields === null)) {
      this.enableAutoGenFields = this.componentDefinition.enableAutoGenFields;
    } else {
      this.enableAutoGenFields = false;
    }

    if (!(typeof this.componentDefinition.helpDisplayWidth === 'undefined' || this.componentDefinition.helpDisplayWidth === null)) {
      this.helpDisplayWidth = this.componentDefinition.helpDisplayWidth;
    } else {
      this.helpDisplayWidth = 'max-content';
    }

    this.primaryStyle = this.getPrimaryStyle();

    if (!(typeof this.componentDefinition.color === 'undefined' || this.componentDefinition.color === null)) {
      this.color = this.componentDefinition.color;
    }

    const compSub = this.changedDocumentService.watchComponentTemplate(this.template.documentId).subscribe(components => {
      components.filter(tplItem => tplItem.name === this.fieldName).forEach(tplItem => {

        this.componentDefinition = tplItem;
        this.disabled = tplItem.enabled === false;

        this.detectChanges();
      });
    });

    this.subs.add(compSub);

    const compThis = this;
    const updateDocumentSub = this.broadcastService.on('document:updated').subscribe((docs) => {
      if (compThis.selectedFieldName && compThis.componentDefinition.helpDocumentId !== docs[0].documentId) {
        if (docs[0].systemHeader.templateId === compThis.defaultHelpTemplateId) {
          console.log('document:updated', docs[0].systemHeader.templateId, compThis.selectedFieldName, docs);
          compThis.modifiedDocument = docs;
          compThis.fnAutoUpdateTemplateDocument(docs);
        }
      }
    });
    this.subs.add(updateDocumentSub);

    const loadedDocumentSub = this.broadcastService.on('document:loaded').subscribe(async (docs) => {
      if (compThis.selectedFieldName) {
        console.log('document:loaded', compThis.selectedFieldName, compThis.fieldName, docs);
        const helpButtonParentDiv = document.querySelector('#divParent' + this.componentDefinition.name + this.key);
        helpButtonParentDiv.classList.add('help-button-no-margin-class');
        setTimeout(async () => {
          await compThis.fnShowHelpDetails();
        },300);
      }
    });
    this.subs.add(loadedDocumentSub);

    setTimeout(() => {
      const helpButtonParentDiv = document.querySelector('#divParent' + this.componentDefinition.name + this.key);
      helpButtonParentDiv.classList.add('help-button-no-margin-class');
      if (this.disabled) {
        helpButtonParentDiv.classList.remove('disabled');
        helpButtonParentDiv.classList.remove('readonly');
      }
    });


    if (typeof this.componentDefinition.helpTemplateId === 'undefined' || this.componentDefinition.helpTemplateId === null) {
      // Use Default help template if undefined
      if ((typeof this.componentDefinition.helpDocumentId === 'undefined' || this.componentDefinition.helpDocumentId === null)) {
        this.componentDefinition.helpTemplateId = this.defaultHelpTemplateId;
      }
    }
    if (typeof this.componentDefinition.helpFormat === 'undefined' || this.componentDefinition.helpFormat === null) {
      // helpFormat default value is HTML
      this.componentDefinition.helpFormat = 'HTML';
    }
    if (typeof this.componentDefinition.helpFieldName === 'undefined' || this.componentDefinition.helpFieldName === null) {
      this.componentDefinition.helpFieldName = this.fieldName + 'Details';
    }

    this.hasAccess = this.sclUtilValidation.checkAccess(this.componentDefinition.keyIds, this.userAccountControlDocument, 'Update');
    if (!this.hasAccess) {
      this.disabled = true;
    }

    const eventRefreshedSelectedFieldName = () => {
      // console.log('eventRefreshedSelectedFieldName triggered', this.fieldName);
      this.selectedFieldName = null;
    };
    this.utilSharingNgService.fnRegisterFunctions([{
        name: 'refreshedSelectedFieldName',
        fn: eventRefreshedSelectedFieldName
      }]
      , 'refreshedSelectedFieldName', null);

  }

  getPrimaryStyle() {
    if (this.componentDefinition.hasOwnProperty('style')) {
      return this.componentDefinition.style;
    } else {
      return this.defaultStyle;
    }
  }


  openHelpPopup($event: MouseEvent, helpFieldName: any, btnHelpEl?) {
    // console.log($event, helpFieldName);
     if(!this.btnHelpElem){
       this.btnHelpElem = btnHelpEl;
     }
     this.btnHelpElem._elementRef.nativeElement.disabled = true;
    if (!this.hasAccess) {
      this.disabled = true;
      logger.info('User has no key to access the editable mode of sc-help-button fieldName:' + this.fieldName);
    }
    this.isMainDocumentDirty = this.modifiedFieldService.isDirty();
    setTimeout(() => {
      this.utilSharingNgService.fnCallFunction('refreshedSelectedFieldName', 'refreshedSelectedFieldName', null, null);
    });

    try {
      const link = '/form/' + this.componentDefinition.helpDocumentId;
      const url = this.sclUtilUrlService.getDocIdFromLink(link);
      this.selectedFieldName = this.fieldName;
      this.selectedHelpFieldName = helpFieldName;
      this.modalTitle = ' ';
      this.helpUrl = link;
      // console.log(scope.selectedFieldName,scope.selectedHelpFieldName);
      // Check if helpDetails is in Template
      const self = this;
      this.dataService.getDocument(this.componentDefinition.helpTemplateId)
        .then((tplResponse) => {

          const newTestTemplate = JSON.parse(JSON.stringify(tplResponse));
          const tplComponents = JSON.parse(JSON.stringify(tplResponse.components));
          let isFoundTplComponents = false;
          let helpCompName = null;
          if (self.componentDefinition.helpFormat === 'HTML') {
            helpCompName = 'sc-rich-text-editor';
          } else if (self.componentDefinition.helpFormat === 'MARKDOWN') {
            helpCompName = 'sc-markdown';
          }
          if (newTestTemplate.documentId === self.defaultHelpTemplateId) {
            for (const key in tplComponents) {
              if (tplComponents[key]) {
                const helpCompFieldName = self.componentDefinition.helpFormat === 'HTML'
                  ? self.componentDefinition.helpFieldName + 'Html' : self.componentDefinition.helpFieldName + 'Markdown';
                if (tplComponents[key].name === helpCompFieldName
                  && tplComponents[key].componentName === helpCompName) {
                  isFoundTplComponents = true;
                }
              }
            }
          }
          if (!isFoundTplComponents && this.enableAutoGenFields) {
            // if not found helpDetails template component, auto-insert helpDetails editor component
            let compName = null;
            let isSupportHelpFormat: boolean;
            if (helpCompName === 'sc-rich-text-editor') {
              isSupportHelpFormat = true;
              compName = 'sc-rich-text-editor';
            } else if (helpCompName === 'sc-markdown') {
              isSupportHelpFormat = true;
              compName = 'sc-markdown';
            } else {
              // helpFormat not supported
              isSupportHelpFormat = false;
              self.notificationService.info('helpFormat=>' + self.componentDefinition.helpFormat + ' is not supported.');
            }

            if (isSupportHelpFormat) {
              const HtmlComponent = {
                componentName: compName,
                fullWidth: true,
                visible: false,
                enabled: false,
                label: self.componentDefinition.helpFormat === 'HTML' ?
                  self.componentDefinition.helpFieldName + 'Html' : self.componentDefinition.helpFieldName + 'Markdown',
                name: self.componentDefinition.helpFormat === 'HTML' ?
                  self.componentDefinition.helpFieldName + 'Html' : self.componentDefinition.helpFieldName + 'Markdown',
                helpComment: '#THIS IS AN AUTOGENERATED COMPONENT auto-added by the template=>[' + this.template.documentId + ']' +
                  '::sc-help-button name=>[' + this.fieldName + ']'

              };
              newTestTemplate.components.push(HtmlComponent);
              // console.log(newTestTemplate);
              // Auto-update for auto-insert helpDetails

              self.dataService.deepDiffUpdate(tplResponse, newTestTemplate)
                // tslint:disable-next-line:no-shadowed-variable
                .then((data) => {
                    console.log('AutoUpdate test Component template Completed', data);
                    self.fnCallModalPopup(url, $event);
                  },
                  (err) => {
                    console.error('AutoUpdate test Component Fail.', err);
                  });
            }

          } else {
            self.fnCallModalPopup(url, $event);
          }

        }, (error) => {
          if (this.enableAutoGenFields) {
            console.error(error);
            this.notificationService.info('helpTemplateId is undefined for helpDocumentId=>' +
              '' + this.componentDefinition.helpDocumentId + '' +
              '.Either remove the setting of helpDocumentId to use the default helpTemplate document ' +
              'or provide the correct helpTemplateId of helpDocumentId:' +
              '' + this.componentDefinition.helpDocumentId + '.');
          } else {
            self.fnCallModalPopup(url, $event);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  fnCallModalPopup(url, $event) {
    this.modalTitle = this.componentDefinition.label;
    // Check document if found
    this.fnFormatCssStyleComponent();
    const componentThis = this;
    this.dataService.getDocument(url)
      .then(function successFunc(helpDocResponse) {
          // console.log(docData);
          if (helpDocResponse) {
            // check if saved helpDocument contains old fieldValue saved
            // console.log('fnCallModalPopup', helpDocResponse);
            let isContainOldFieldValue = false;
            let strLogInfo = '';
            if ((componentThis.componentDefinition.helpTemplateId === componentThis.defaultHelpTemplateId)
              && !componentThis.enableAutoGenFields) {
              if (componentThis.componentDefinition.helpFormat === 'HTML') {
                if (helpDocResponse[componentThis.componentDefinition.helpFieldName + 'Html']) {
                  strLogInfo = 'The saved helpDocument contains old FieldName: "' + componentThis.componentDefinition.helpFieldName + 'Html."\n' +
                    'Config saved fieldName="' + componentThis.componentDefinition.helpFieldName + '" when helpFormat="HTML" and  enableAutoGenFields=false or undefined.\n' +
                    'Please check saved document:('+url+') and \nchange the saved helpDocument fieldName to "' +
                    '' + componentThis.componentDefinition.helpFieldName + '" to view the old saved help details.\n' +
                    'Remove all other saved fieldValue in document('+url+') except for the fieldValue of ' +
                    'fieldName:"' + componentThis.componentDefinition.helpFieldName + '"';
                  isContainOldFieldValue = true;
                }
              } else if (componentThis.componentDefinition.helpFormat === 'MARKDOWN') {
                if (helpDocResponse[componentThis.componentDefinition.helpFieldName]) {
                  strLogInfo = 'The saved helpDocument('+url+') contains old FieldName: "'+componentThis.componentDefinition.helpFieldName+'".\n' +
                    'Config would saved fieldName="' + componentThis.componentDefinition.helpFieldName + 'Markdown" when helpFormat="MARKDOWN". \n' +
                    'Please check saved document:('+url+') and change the saved helpDocument fieldName to "' +
                    '' + componentThis.componentDefinition.helpFieldName + 'Markdown" to view the old saved help details.\n' +
                    'Remove all other saved fieldValue in document('+url+') except for the fieldValue of ' +
                    'fieldName:"' + componentThis.componentDefinition.helpFieldName + 'Markdown"';
                  isContainOldFieldValue = true;

                }
              }
            }
            if(isContainOldFieldValue){
              // info message guide to display the old help details
              componentThis.notificationService.printMessage(strLogInfo+'<br>(see browser console log to view the help guide clearly)', 'info','Help Guide Info', '', false, undefined,null, 0, true);
              console.log('%c' + strLogInfo, 'color: white; background: blue; font-size: 12px');
            }


            componentThis.helpUrl = url;
            setTimeout(() => {
              componentThis.selectedFieldName = componentThis.fieldName;
              componentThis.documentModalService.openDocumentInModal(url, componentThis)
                .then(
                  () => {
                    console.log('openDocumentInModal Complete!');
                    $('#customHelpStyle').remove();
                  },
                  () => {
                    console.log('openDocumentInModal Errored!');
                    $('#customHelpStyle').remove();
                  },
                );

              if ($event) {
                $event.preventDefault();
              }
              componentThis.btnHelpElem._elementRef.nativeElement.disabled = false;
            }, 300);
          }
        },
        function errorFunc(err) {
          // If helpDocumentId is not found, redirect Modal to helpTemplateId to create new help content*/
          console.log(url, ' not found', err);
          componentThis.helpUrl = componentThis.componentDefinition.helpTemplateId;
          setTimeout(() => {
            componentThis.fnFormatCssStyleComponent();
            componentThis.selectedFieldName = componentThis.fieldName;
            componentThis.documentModalService.openDocumentInModal(componentThis.componentDefinition.helpTemplateId, componentThis)
              .then(
                () => {
                  console.log('openDocumentInModal Complete!');
                  $('#customHelpStyle').remove();
                },
                () => {
                  console.log('openDocumentInModal Errored!');
                  $('#customHelpStyle').remove();
                },
              );
            if ($event) {
              $event.preventDefault();
            }
            componentThis.btnHelpElem._elementRef.nativeElement.disabled = false;
          });
        });
  }

  fnFormatCssStyleComponent() {
    setTimeout(() => {
      $('#customHelpStyle').remove();
      const style = document.createElement('style');
      style.setAttribute('id', 'customHelpStyle');
      let helpFieldNameWithSuffix;
      if (this.componentDefinition.helpTemplateId === this.defaultHelpTemplateId) {
        helpFieldNameWithSuffix = this.componentDefinition.helpFormat === 'HTML' ?
          this.componentDefinition.helpFieldName + 'Html' : this.componentDefinition.helpFieldName + 'Markdown';
      } else {
        helpFieldNameWithSuffix = this.componentDefinition.helpFieldName;
      }
      let styleFormFieldLabel = '';
      if (this.componentDefinition.helpTemplateId === this.defaultHelpTemplateId) {
        styleFormFieldLabel = '.mat-dialog-container ft-template .mat-form-field-label-wrapper,' +
          '.mat-dialog-container .classGblMarkDown mat-label{display:none!important;} ';
      }
      const isEditableCss = this.disabled ? '.mat-dialog-container ft-template div[id^="divParent' +
        '' + helpFieldNameWithSuffix + '"] .mat-slide-toggle,.mat-dialog-container ft-template div[id^="divParent' +
        '' + this.componentDefinition.helpFieldName + '"] .mat-slide-toggle,.mat-dialog-container ft-template div[id^="divParent' +
        '' + helpFieldNameWithSuffix + '"] .gbl-mark-down-checkbox{display:none;pointer-events:none;}' : '';
      const helpDisplayWidthCss = '.ft-document-dialog { width: ' + this.helpDisplayWidth + '!important; }';
      style.textContent = styleFormFieldLabel +
        '.divTemplateDialog{ max-height: 90vh; min-height: 90vh;min-width:77vw;} ' +
        '.mat-dialog-container .mat-dialog-content{opacity:0; display: none;} ' +
        '.mat-dialog-container ft-template .mat-form-field-infix{    margin-top: -8px; border: none;}' +
        '' + isEditableCss + '' +
        '' + helpDisplayWidthCss + '';
      document.getElementsByTagName('head')[0].appendChild(style);
    });

  }

  async fnShowHelpDetails() {
    // console.log('fnFormatDesignInJs', this.selectedHelpFieldName, this.componentDefinition.helpFieldName);
    // Run show/hide other elements if using default helpTemplateId:cb1af5c0-95e2-11e9-8108-e9db4351ffae
    if (this.enableAutoGenFields) {
      this.enableField(this.componentDefinition.helpFormat === 'HTML' ?
        this.componentDefinition.helpFieldName + 'Html' : this.componentDefinition.helpFieldName + 'Markdown', !this.disabled, true);
      if (this.componentDefinition.helpTemplateId === this.defaultHelpTemplateId) {
        this.showField('', false, true);
        this.showField(this.componentDefinition.helpFormat === 'HTML' ?
          this.componentDefinition.helpFieldName + 'Html' : this.componentDefinition.helpFieldName + 'Markdown', true, false, true);
      }else{
        const elemMatDialogContent: any = document.querySelector('.mat-dialog-container .mat-dialog-content');
        if(elemMatDialogContent){
          elemMatDialogContent.style.opacity = 1;
          elemMatDialogContent.style.display = 'block';
        }
      }
    } else {
      this.enableField(this.componentDefinition.helpFormat === 'MARKDOWN' ?
        this.componentDefinition.helpFieldName + 'Markdown' : this.componentDefinition.helpFieldName, !this.disabled, true);
      if (this.componentDefinition.helpTemplateId === this.defaultHelpTemplateId) {
        this.showField('', false, true);
        this.showField(this.componentDefinition.helpFormat === 'MARKDOWN' ?
          this.componentDefinition.helpFieldName + 'Markdown' : this.componentDefinition.helpFieldName, true, false, true);
      }else{
        const elemMatDialogContent: any = document.querySelector('.mat-dialog-container .mat-dialog-content');
        if(elemMatDialogContent){
          elemMatDialogContent.style.opacity = 1;
          elemMatDialogContent.style.display = 'block';
        }
      }
    }
    if (this.componentDefinition.helpFormat === 'MARKDOWN') {
      if (this.disabled || (!this.hasAccess)) {
        this.updateConfigTemplateCompDefinition(this.componentDefinition.helpFormat === 'MARKDOWN' ?
          this.componentDefinition.helpFieldName + 'Markdown' : this.componentDefinition.helpFieldName, 'displayMode', 'viewOnly');
        this.updateConfigTemplateCompDefinition(this.componentDefinition.helpFieldName, 'displayMode', 'viewOnly');
      }
      this.updateConfigTemplateCompDefinition(this.componentDefinition.helpFormat === 'MARKDOWN' ?
        this.componentDefinition.helpFieldName + 'Markdown' : this.componentDefinition.helpFieldName, 'hideLabel', true);
      this.updateConfigTemplateCompDefinition(this.componentDefinition.helpFieldName, 'hideLabel', true);
    }

  }

  private showField(fieldName, flag, isAllField, showHelpContent?) {
    // console.log('showField', fieldName, this.componentDefinition.name);
    const selfThis = this;
    selfThis.dataService.getDocument(selfThis.componentDefinition.helpTemplateId)
      .then(function successFunc(helpDocTemplate) {
          // console.log(helpDocTemplate, fieldName);
          if (helpDocTemplate) {
            if (helpDocTemplate && helpDocTemplate.components) {
              // tslint:disable-next-line:prefer-for-of
              for (let i = 0; i < helpDocTemplate.components.length; i++) {
                if (helpDocTemplate.components[i]) {
                  const tplItem = helpDocTemplate.components[i];
                  if (isAllField) {
                    helpDocTemplate.components[i].visible = flag;
                    selfThis.changedDocumentService.setComponentFlagTemplate(helpDocTemplate.documentId, tplItem.name, 'visible', flag);


                  } else {
                    if (tplItem.name === fieldName) {
                      helpDocTemplate.components[i].visible = flag;
                      selfThis.changedDocumentService.setComponentFlagTemplate(helpDocTemplate.documentId, tplItem.name, 'visible', flag);
                    }
                  }
                }
              }
              if(showHelpContent){
                const elemMatDialogContent: any = document.querySelector('.mat-dialog-container .mat-dialog-content');
                if(elemMatDialogContent){
                  elemMatDialogContent.style.opacity = 1;
                  elemMatDialogContent.style.display = 'block';
                }
              }
              selfThis.detectChanges();

            }
          }
        },
        function errorFunc(err) {
          console.log('not found template', err);
        });


  }

  private updateConfigTemplateCompDefinition(fieldName, flagName,flagValue) {
    // console.log('updateConfigTemplateCompDefinition', flagName, flagValue);
    const selfThis = this;
    selfThis.dataService.getDocument(selfThis.componentDefinition.helpTemplateId)
      .then(function successFunc(helpDocTemplate) {
          // console.log(helpDocTemplate, fieldName);
          if (helpDocTemplate) {
            if (helpDocTemplate && helpDocTemplate.components) {
              // tslint:disable-next-line:prefer-for-of
              for (let i = 0; i < helpDocTemplate.components.length; i++) {
                if (helpDocTemplate.components[i]) {
                  const tplItem = helpDocTemplate.components[i];
                    if (tplItem.name === fieldName) {
                      helpDocTemplate.components[i][flagName] = flagValue;
                      selfThis.changedDocumentService.setComponentFlagTemplate(helpDocTemplate.documentId,
                        tplItem.name, flagName, flagValue);
                    }
                }
              }

            }
          }
        },
        function errorFunc(err) {
          console.log('not found template', err);
        });
  }

  private enableField(fieldName, flag, isAllField) {
    // console.log('enableField', fieldName, this.componentDefinition.name);
    const selfThis = this;
    selfThis.dataService.getDocument(selfThis.componentDefinition.helpTemplateId)
      .then(function successFunc(helpDocTemplate) {
          // console.log(helpDocTemplate, fieldName);
          if (helpDocTemplate) {
            if (helpDocTemplate && helpDocTemplate.components) {
              // tslint:disable-next-line:prefer-for-of
              for (let i = 0; i < helpDocTemplate.components.length; i++) {
                if (helpDocTemplate.components[i]) {
                  const tplItem = helpDocTemplate.components[i];
                  if (isAllField) {
                    helpDocTemplate.components[i].enabled = flag;
                    selfThis.changedDocumentService.setComponentFlagTemplate(helpDocTemplate.documentId, tplItem.name, 'enabled', flag);


                  } else {
                    if (tplItem.name === fieldName) {
                      helpDocTemplate.components[i].enabled = flag;
                      selfThis.changedDocumentService.setComponentFlagTemplate(helpDocTemplate.documentId, tplItem.name, 'enabled', flag);
                    } else {
                      selfThis.changedDocumentService.setComponentFlagTemplate(helpDocTemplate.documentId, tplItem.name, 'enabled', false);
                    }
                  }
                }
              }

            }
          }
        },
        function errorFunc(err) {
          console.log('not found template', err);
        });


  }

  fnUpdateDocument(newTestTemplate, documentTemplate, selectedFieldName) {
    const tpl = JSON.parse(JSON.stringify(newTestTemplate));
    const components = newTestTemplate.components;
    let isTemplateNeededUpdate = false;
    for (const key in components) {
      if (components[key].componentName === 'sc-help-button' && components[key].name === selectedFieldName) {
        //  console.log(key,components[key],newTestTemplate.components[key].helpDocumentId,documentTemplate[0].documentId);
        if (typeof components[key].helpFormat === 'undefined' || components[key].helpFormat === null) {
          newTestTemplate.components[key].helpFormat = 'HTML';
        }
        if (typeof components[key].helpFieldName === 'undefined' || components[key].helpFieldName === null) {
          newTestTemplate.components[key].helpFieldName = selectedFieldName + 'Details';
        }
        if ((typeof components[key].helpDocumentId === 'undefined' || components[key].helpDocumentId === null)) {
          newTestTemplate.components[key].helpDocumentId = documentTemplate[0].documentId;
          isTemplateNeededUpdate = true;
        }
        if (components[key].helpDocumentId !== documentTemplate[0].documentId) {
          newTestTemplate.components[key].helpDocumentId = documentTemplate[0].documentId;
          isTemplateNeededUpdate = true;
        }
        if (typeof components[key].helpTemplateId === 'undefined' || components[key].helpTemplateId === null) {
          newTestTemplate.components[key].helpTemplateId = 'cb1af5c0-95e2-11e9-8108-e9db4351ffae';
        }
      }
    }
    // console.log(newTestTemplate);
    if (isTemplateNeededUpdate) {
      this.dataService.deepDiffUpdate(tpl, newTestTemplate)
        // tslint:disable-next-line:no-shadowed-variable
        .then((data) => {
            console.log('Auto-updated test template complete', data);
            // $timeout(function() {
            this.componentDefinition.helpDocumentId = documentTemplate[0].documentId;
            // }, 300);
          },
          (err) => {
            console.error('Auto-updated test template  fail.', err);
          });
    }

  }

  fnAutoUpdateTemplateDocument(documentTemplate) {
    if (this.enableAutoGenFields) {
      const selfThis = this;
      this.dataService.getDocument(this.template.documentId).then(
        function successFunc(tpl) {
          console.log(tpl);
          selfThis.fnUpdateDocument(tpl, documentTemplate, selfThis.selectedFieldName);
          selfThis.modifiedDocument = null;
          selfThis.selectedFieldName = null;
        }, function errorFunc(err) {
          console.error(err);
        });
    }
  }

}
